import { css } from "styled-components";
import { riotProductSkin } from "../riot-product";
import { BladeHeaderBody } from "../../../../components/BladeHeader";
import { BackdropForeground } from "../../../../components/Backdrop";
export const lolProductSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}
  ${BladeHeaderBody} p {
    max-width: 625px;
  }

  ${BackdropForeground} {
    right: 0;
    width: auto;
  }

  .platform-icons img {
    margin-right: 32px;
  }

  .gradient-container {
    @media (width <= 1280px) {
      background-image: linear-gradient(45deg, ${paletteTokens.bladebg1}e6 42.68%, ${paletteTokens.bladebg1}00 69.38%);
    }

    ${chroma.mediaQueries.mobileDown} {
      background-image: linear-gradient(45deg, ${paletteTokens.bladebg1}e6 46.38%, ${paletteTokens.bladebg1}00 77.79%);
    }
  }
`;
//# sourceMappingURL=index.js.map